import { Component, Input, OnInit, AfterViewInit, ElementRef, QueryList, ViewChildren, ViewChild, HostBinding } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';

import { SideNavState } from '../../models/side-nav-state.model';
import { LEFT_SIDE_NAVIGATION } from '../../constants/side-nav';
import { expansionAnimations } from '../../constants/animations';
import { DLSRouteStateService } from '../../../core/services/dls-route-state/dls-route-state.service';

@Component({
  selector: 'dls-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss'],
  animations: [
    expansionAnimations.bodyExpansion,
    expansionAnimations.indicatorRotate
  ]
})
export class SideNavigationMenuComponent implements OnInit {

  @HostBinding('class.dls-side-nav-wrapper') private navWrapperClass: boolean;

  // Readonly
  public get _routeState(): 'design' | 'develop' | null {
    return this._dlsRouteState.state;
  }

  public _currentURL: string;
  public sideNavItems: SideNavState[];

  constructor(
    private _router: Router,
    private _dlsRouteState: DLSRouteStateService
  ) {
    this.sideNavItems = LEFT_SIDE_NAVIGATION;

    // To set the default state and transition
    this._currentURL = '';

    this.navWrapperClass = true;
  }

  ngOnInit() {

    // Listen to NavigationEnd event
    this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    ).subscribe((route: NavigationEnd) => {

      // To fetch the current URL
      this._currentURL = route.urlAfterRedirects;

      this.sideNavItems.forEach(navItem => {
        // Update every navigation item expanded state
        navItem.expand = this._updateExpandState(navItem);
        navItem.active = this._updateExpandState(navItem, true);
      });
    });

    // To fetch the current URL on load
    this._currentURL = this._router.url;

    let isSideNavExpanded = false;
    // Update panels expand state
    this.sideNavItems.forEach(navItem => {
      // Update every navigation item expanded state
      navItem.expand = this._updateExpandState(navItem, true);
      navItem.active = navItem.expand;
      isSideNavExpanded = navItem.active ? navItem.active : isSideNavExpanded;
    });

    // Expands the Component category if no route matched
    if (!isSideNavExpanded) {
      // Components
      this.sideNavItems[2].active
        = this.sideNavItems[2].expand
        = true;
    }
  }

  /** Gets the expanded state string. */
  _getExpandedState(isOpen: boolean) {
    return isOpen ? 'expanded' : 'collapsed';
  }

  // Toggles expand state
  public togglePanel(index: number) {
    this.sideNavItems[index].expand = !this.sideNavItems[index].expand;
  }

  // To compare the existing route with the current route
  public _checkRouteChange(elementRoute: string, currentUrl: string) {
    return currentUrl.indexOf(elementRoute) !== -1;
  }

  /**
   * @param force : boolean
   *  true: Expands panel associated to current URL and collapse all other
   *  false: Only expands panel associated to current URL and does not alter other panel states
   */
  private _updateExpandState(navItem: SideNavState, force?: boolean): boolean {
    return !navItem.expand || force
      ? this._checkRouteChange(navItem.basePath, this._currentURL)
      : navItem.expand;
  }
}
